let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cBsb5")).then(() => parcelRequire('gpOYK'));